export const planeSeatSpecifics  = {

    'A330900NEO': {
        business: {
            features: [
                'addMoreSidebars.seatmap.text.fullFlatReclinableSeat',
                'addMoreSidebars.seatmap.text.widerSeats',
                'addMoreSidebars.seatmap.text.backrestLevels',
                'addMoreSidebars.seatmap.text.electricalUsbOutlets'
            ],
            images: [
                { src: './assets/images/ancillaries/seats/A330-NEO/Executive/01.jpg', label: 'addMoreSidebars.seatmap.label.businessSEAT' },
                { src: './assets/images/ancillaries/seats/A330-NEO/Executive/02.jpg', label: 'addMoreSidebars.seatmap.label.businessSEAT' },
                { src: './assets/images/ancillaries/seats/A330-NEO/Executive/03.jpg', label: 'addMoreSidebars.seatmap.label.businessSEAT' },
                { src: './assets/images/ancillaries/seats/A330-NEO/Executive/04.jpg', label: 'addMoreSidebars.seatmap.label.businessSEAT' },
                { src: './assets/images/ancillaries/seats/A330-NEO/Executive/05.jpg', label: 'addMoreSidebars.seatmap.label.businessSEAT' },
                { src: './assets/images/ancillaries/seats/A330-NEO/Executive/06.jpg', label: 'addMoreSidebars.seatmap.label.businessSEAT' },
                { src: './assets/images/ancillaries/seats/A330-NEO/Executive/07.jpg', label: 'addMoreSidebars.seatmap.label.businessSEAT' }
            ]
        },
        comfort: {
            features: [
                'addMoreSidebars.seatmap.text.frontOfCabinSeat',
                'addMoreSidebars.seatmap.text.extraReclinable',
                'addMoreSidebars.seatmap.text.moreLegroom',
                'addMoreSidebars.seatmap.text.usbOutlet'
            ],
            images: [
                { src: './assets/images/ancillaries/seats/A330-NEO/Comfort/01.jpg', label: 'addMoreSidebars.seatmap.label.preferredSEAT' },
                { src: './assets/images/ancillaries/seats/A330-NEO/Comfort/02.jpg', label: 'addMoreSidebars.seatmap.label.preferredSEAT' },
                { src: './assets/images/ancillaries/seats/A330-NEO/Comfort/03.jpg', label: 'addMoreSidebars.seatmap.label.preferredSEAT' },
                { src: './assets/images/ancillaries/seats/A330-NEO/Comfort/04.jpg', label: 'addMoreSidebars.seatmap.label.preferredSEAT' },
                { src: './assets/images/ancillaries/seats/A330-NEO/Comfort/05.jpg', label: 'addMoreSidebars.seatmap.label.preferredSEAT' },
                { src: './assets/images/ancillaries/seats/A330-NEO/Comfort/06.jpg', label: 'addMoreSidebars.seatmap.label.preferredSEAT' }
            ]
        },
        standard: {
            features: [
                'addMoreSidebars.seatmap.text.reclinableSeat',
                'addMoreSidebars.seatmap.text.standardLegroom',
                'addMoreSidebars.seatmap.text.usbOutlet'
            ],
            images: [
                { src: './assets/images/ancillaries/seats/A330-NEO/Standard/01.jpg', label: 'addMoreSidebars.seatmap.label.standardSEAT' },
                { src: './assets/images/ancillaries/seats/A330-NEO/Standard/02.jpg', label: 'addMoreSidebars.seatmap.label.standardSEAT' },
                { src: './assets/images/ancillaries/seats/A330-NEO/Standard/03.jpg', label: 'addMoreSidebars.seatmap.label.standardSEAT' },
                { src: './assets/images/ancillaries/seats/A330-NEO/Standard/04.jpg', label: 'addMoreSidebars.seatmap.label.standardSEAT' }
            ]
        },
        legroom: {
            features: [
                'addMoreSidebars.seatmap.text.frontRowSeat',
                'addMoreSidebars.seatmap.text.moreLegroom',
                'addMoreSidebars.seatmap.text.usbOutlet'
            ],
            images: [
                { src: './assets/images/ancillaries/seats/A330-NEO/LegSpace/01.jpg', label: 'addMoreSidebars.seatmap.label.legroomSEAT' }
            ] 
        },	         
    },
    'A330200RETROFIT': {
        business: {
            features: [
                'addMoreSidebars.seatmap.text.fullFlatReclinableSeat',
                'addMoreSidebars.seatmap.text.widerSeats',
                'addMoreSidebars.seatmap.text.backrestLevels',
                'addMoreSidebars.seatmap.text.electricalUsbOutlets'
            ],
            images: [
                { src: './assets/images/ancillaries/seats/A330-200/Executive/01.jpg', label: 'addMoreSidebars.seatmap.label.businessSEAT' },
                { src: './assets/images/ancillaries/seats/A330-200/Executive/02.jpg', label: 'addMoreSidebars.seatmap.label.businessSEAT' },
                { src: './assets/images/ancillaries/seats/A330-200/Executive/03.jpg', label: 'addMoreSidebars.seatmap.label.businessSEAT' },
                { src: './assets/images/ancillaries/seats/A330-200/Executive/04.jpg', label: 'addMoreSidebars.seatmap.label.businessSEAT' },
                { src: './assets/images/ancillaries/seats/A330-200/Executive/05.jpg', label: 'addMoreSidebars.seatmap.label.businessSEAT' },
                { src: './assets/images/ancillaries/seats/A330-200/Executive/06.jpg', label: 'addMoreSidebars.seatmap.label.businessSEAT' },
                { src: './assets/images/ancillaries/seats/A330-200/Executive/07.jpg', label: 'addMoreSidebars.seatmap.label.businessSEAT' },
                { src: './assets/images/ancillaries/seats/A330-200/Executive/08.jpg', label: 'addMoreSidebars.seatmap.label.businessSEAT' },
                { src: './assets/images/ancillaries/seats/A330-200/Executive/09.jpg', label: 'addMoreSidebars.seatmap.label.businessSEAT' },
                { src: './assets/images/ancillaries/seats/A330-200/Executive/10.jpg', label: 'addMoreSidebars.seatmap.label.businessSEAT' },
                { src: './assets/images/ancillaries/seats/A330-200/Executive/11.jpg', label: 'addMoreSidebars.seatmap.label.businessSEAT' }
            ]
        },
        comfort: {
            features: [
                'addMoreSidebars.seatmap.text.frontOfCabinSeat',
                'addMoreSidebars.seatmap.text.extraReclinable',
                'addMoreSidebars.seatmap.text.moreLegroom',
                'addMoreSidebars.seatmap.text.usbOutlet'
            ],
            images: [
                { src: './assets/images/ancillaries/seats/A330-200/Comfort/01.jpg', label: 'addMoreSidebars.seatmap.label.preferredSEAT' },
                { src: './assets/images/ancillaries/seats/A330-200/Comfort/02.jpg', label: 'addMoreSidebars.seatmap.label.preferredSEAT' },
            ]
        },
        standard: {
            features: [
                'addMoreSidebars.seatmap.text.reclinableSeat',
                'addMoreSidebars.seatmap.text.standardLegroom',
                'addMoreSidebars.seatmap.text.usbOutlet'
            ],
            images: [
                { src: './assets/images/ancillaries/seats/A330-200/Standard/01.jpg', label: 'addMoreSidebars.seatmap.label.standardSEAT' },
                { src: './assets/images/ancillaries/seats/A330-200/Standard/02.jpg', label: 'addMoreSidebars.seatmap.label.standardSEAT' },
                { src: './assets/images/ancillaries/seats/A330-200/Standard/03.jpg', label: 'addMoreSidebars.seatmap.label.standardSEAT' },
                { src: './assets/images/ancillaries/seats/A330-200/Standard/04.jpg', label: 'addMoreSidebars.seatmap.label.standardSEAT' }
            ]
        },
        legroom: {
            features: [
                'addMoreSidebars.seatmap.text.frontRowSeat',
                'addMoreSidebars.seatmap.text.moreLegroom',
                'addMoreSidebars.seatmap.text.usbOutlet'
            ],
            images: [
                { src: './assets/images/ancillaries/seats/A330-200/LegSpace/01.jpg', label: 'addMoreSidebars.seatmap.label.legroomSEAT' }
            ] 
        },	     
    },
    'A321NEO': {	
        business: {
            features: [
                'addMoreSidebars.seatmap.text.greaterComfort',
                'addMoreSidebars.seatmap.text.recliningHeadrest',
                'addMoreSidebars.seatmap.text.electricalUsbOutlets'
            ],
            images: [
                { src: './assets/images/ancillaries/seats/A321-Neo/Executive/01.jpg', label: 'addMoreSidebars.seatmap.label.businessSEAT' },
                { src: './assets/images/ancillaries/seats/A321-Neo/Executive/02.jpg', label: 'addMoreSidebars.seatmap.label.businessSEAT' },
                { src: './assets/images/ancillaries/seats/A321-Neo/Executive/03.jpg', label: 'addMoreSidebars.seatmap.label.businessSEAT' },
                { src: './assets/images/ancillaries/seats/A321-Neo/Executive/04.jpg', label: 'addMoreSidebars.seatmap.label.businessSEAT' },
                { src: './assets/images/ancillaries/seats/A321-Neo/Executive/05.jpg', label: 'addMoreSidebars.seatmap.label.businessSEAT' },
                { src: './assets/images/ancillaries/seats/A321-Neo/Executive/06.jpg', label: 'addMoreSidebars.seatmap.label.businessSEAT' }
            ]
        },			
        comfort: {
            price: '20.00€',
            features: [
                'addMoreSidebars.seatmap.text.frontOfCabinSeat',
                'addMoreSidebars.seatmap.text.extraReclinable',
                'addMoreSidebars.seatmap.text.moreLegroom',
                'addMoreSidebars.seatmap.text.usbOutlet'
            ],
            images: [
                { src: './assets/images/ancillaries/seats/A321-Neo/Comfort/01.jpg', label: 'addMoreSidebars.seatmap.label.preferredSEAT' },
                { src: './assets/images/ancillaries/seats/A321-Neo/Comfort/02.jpg', label: 'addMoreSidebars.seatmap.label.preferredSEAT' },
                { src: './assets/images/ancillaries/seats/A321-Neo/Comfort/03.jpg', label: 'addMoreSidebars.seatmap.label.preferredSEAT' },
                { src: './assets/images/ancillaries/seats/A321-Neo/Comfort/04.jpg', label: 'addMoreSidebars.seatmap.label.preferredSEAT' },
                { src: './assets/images/ancillaries/seats/A321-Neo/Comfort/05.jpg', label: 'addMoreSidebars.seatmap.label.preferredSEAT' },
                { src: './assets/images/ancillaries/seats/A321-Neo/Comfort/06.jpg', label: 'addMoreSidebars.seatmap.label.preferredSEAT' },
                { src: './assets/images/ancillaries/seats/A321-Neo/Comfort/07.jpg', label: 'addMoreSidebars.seatmap.label.preferredSEAT' },
                { src: './assets/images/ancillaries/seats/A321-Neo/Comfort/08.jpg', label: 'addMoreSidebars.seatmap.label.preferredSEAT' }
            ]
        },
        standard: {
            features: ['addMoreSidebars.seatmap.text.standardLegroom'],
            images: [
                { src: './assets/images/ancillaries/seats/A321-Neo/Standard/01.jpg', label: 'addMoreSidebars.seatmap.label.standardSEAT' },
                { src: './assets/images/ancillaries/seats/A321-Neo/Standard/02.jpg', label: 'addMoreSidebars.seatmap.label.standardSEAT' },
                { src: './assets/images/ancillaries/seats/A321-Neo/Standard/03.jpg', label: 'addMoreSidebars.seatmap.label.standardSEAT' }
            ]
        }
    },
    'A321LR': {
        business: {
            features: [
                'addMoreSidebars.seatmap.text.fullFlatReclinableSeat',
                'addMoreSidebars.seatmap.text.widerSeats',
                'addMoreSidebars.seatmap.text.backrestLevels',
                'addMoreSidebars.seatmap.text.electricalUsbOutlets'
            ],
            images: [
                { src: './assets/images/ancillaries/seats/A321-LR/Executive/01.jpg', label: 'addMoreSidebars.seatmap.label.businessSEAT' },
                { src: './assets/images/ancillaries/seats/A321-LR/Executive/02.jpg', label: 'addMoreSidebars.seatmap.label.businessSEAT' },
                { src: './assets/images/ancillaries/seats/A321-LR/Executive/03.jpg', label: 'addMoreSidebars.seatmap.label.businessSEAT' },
                { src: './assets/images/ancillaries/seats/A321-LR/Executive/04.jpg', label: 'addMoreSidebars.seatmap.label.businessSEAT' }
            ]
        },
        comfort: {
            features: [
                'addMoreSidebars.seatmap.text.frontOfCabinSeat',
                'addMoreSidebars.seatmap.text.extraReclinable',
                'addMoreSidebars.seatmap.text.moreLegroom',
                'addMoreSidebars.seatmap.text.usbOutlet'
            ],
            images: [
                { src: './assets/images/ancillaries/seats/A321-LR/Comfort/01.jpg', label: 'addMoreSidebars.seatmap.label.preferredSEAT' },
                { src: './assets/images/ancillaries/seats/A321-LR/Comfort/02.jpg', label: 'addMoreSidebars.seatmap.label.preferredSEAT' },
                { src: './assets/images/ancillaries/seats/A321-LR/Comfort/03.jpg', label: 'addMoreSidebars.seatmap.label.preferredSEAT' }
            ]
        },
        standard: {
            features: [
                'addMoreSidebars.seatmap.text.reclinableSeat',
                'addMoreSidebars.seatmap.text.standardLegroom',
                'addMoreSidebars.seatmap.text.usbOutlet'
            ],
            images: [
                { src: './assets/images/ancillaries/seats/A321-LR/Standard/01.jpg', label: 'addMoreSidebars.seatmap.label.standardSEAT' },
                { src: './assets/images/ancillaries/seats/A321-LR/Standard/02.jpg', label: 'addMoreSidebars.seatmap.label.standardSEAT' }
            ]
        },
        legroom: {
            features: [
                'addMoreSidebars.seatmap.text.frontRowSeat',
                'addMoreSidebars.seatmap.text.moreLegroom',
                'addMoreSidebars.seatmap.text.usbOutlet'
            ],
            images: [
                { src: './assets/images/ancillaries/seats/A321-LR/LegSpace/01.jpg', label: 'addMoreSidebars.seatmap.label.legroomSEAT' }
            ] 
        },	        
    },
    'A321': {
        business: {
            features: [
                'addMoreSidebars.seatmap.text.greaterComfort',
                'addMoreSidebars.seatmap.text.recliningHeadrest',
                'addMoreSidebars.seatmap.text.electricalUsbOutlets'
            ],
            images: [
                { src: './assets/images/ancillaries/seats/A321/Executive/01.jpg', label: 'addMoreSidebars.seatmap.label.businessSEAT' },
                { src: './assets/images/ancillaries/seats/A321/Executive/02.jpg', label: 'addMoreSidebars.seatmap.label.businessSEAT' },
                { src: './assets/images/ancillaries/seats/A321/Executive/03.jpg', label: 'addMoreSidebars.seatmap.label.businessSEAT' },
                { src: './assets/images/ancillaries/seats/A321/Executive/04.jpg', label: 'addMoreSidebars.seatmap.label.businessSEAT' },
                { src: './assets/images/ancillaries/seats/A321/Executive/05.jpg', label: 'addMoreSidebars.seatmap.label.businessSEAT' },
                { src: './assets/images/ancillaries/seats/A321/Executive/06.jpg', label: 'addMoreSidebars.seatmap.label.businessSEAT' }
            ]
        },			
        comfort: {
            features: [
                'addMoreSidebars.seatmap.text.frontOfCabinSeat',
                'addMoreSidebars.seatmap.text.moreLegroom',
                'addMoreSidebars.seatmap.text.extraReclinable',
                'addMoreSidebars.seatmap.text.usbOutlet'
            ],
            images: [
                { src: './assets/images/ancillaries/seats/A321/Comfort/01.jpg', label: 'addMoreSidebars.seatmap.label.preferredSEAT' },
                { src: './assets/images/ancillaries/seats/A321/Comfort/02.jpg', label: 'addMoreSidebars.seatmap.label.preferredSEAT' },
                { src: './assets/images/ancillaries/seats/A321/Comfort/03.jpg', label: 'addMoreSidebars.seatmap.label.preferredSEAT' },
                { src: './assets/images/ancillaries/seats/A321/Comfort/04.jpg', label: 'addMoreSidebars.seatmap.label.preferredSEAT' },
                { src: './assets/images/ancillaries/seats/A321/Comfort/05.jpg', label: 'addMoreSidebars.seatmap.label.preferredSEAT' },
                { src: './assets/images/ancillaries/seats/A321/Comfort/06.jpg', label: 'addMoreSidebars.seatmap.label.preferredSEAT' },
                { src: './assets/images/ancillaries/seats/A321/Comfort/07.jpg', label: 'addMoreSidebars.seatmap.label.preferredSEAT' }
            ]
        },
        standard: {
            features: ['addMoreSidebars.seatmap.text.standardLegroom'],
            images: [
                { src: './assets/images/ancillaries/seats/A321/Standard/01.jpg', label: 'addMoreSidebars.seatmap.label.standardSEAT' },
                { src: './assets/images/ancillaries/seats/A321/Standard/02.jpg', label: 'addMoreSidebars.seatmap.label.standardSEAT' },
                { src: './assets/images/ancillaries/seats/A321/Standard/03.jpg', label: 'addMoreSidebars.seatmap.label.standardSEAT' },
            ]
        },			
    },
    'A320NEO': {
        business: {
            features: [
                'addMoreSidebars.seatmap.text.greaterComfort',
                'addMoreSidebars.seatmap.text.recliningHeadrest',
                'addMoreSidebars.seatmap.text.electricalUsbOutlets'
            ],
            images: [
                { src: './assets/images/ancillaries/seats/A320-Neo/Executive/01.jpg', label: 'addMoreSidebars.seatmap.label.businessSEAT' },
                { src: './assets/images/ancillaries/seats/A320-Neo/Executive/02.jpg', label: 'addMoreSidebars.seatmap.label.businessSEAT' },
                { src: './assets/images/ancillaries/seats/A320-Neo/Executive/03.jpg', label: 'addMoreSidebars.seatmap.label.businessSEAT' },
                { src: './assets/images/ancillaries/seats/A320-Neo/Executive/04.jpg', label: 'addMoreSidebars.seatmap.label.businessSEAT' },
                { src: './assets/images/ancillaries/seats/A320-Neo/Executive/05.jpg', label: 'addMoreSidebars.seatmap.label.businessSEAT' },
                { src: './assets/images/ancillaries/seats/A320-Neo/Executive/06.jpg', label: 'addMoreSidebars.seatmap.label.businessSEAT' }
            ]
        },			
        comfort: {
            price: '20.00€',
            features: [
                'addMoreSidebars.seatmap.text.frontOfCabinSeat',
                'addMoreSidebars.seatmap.text.extraReclinable',
                'addMoreSidebars.seatmap.text.moreLegroom',
                'addMoreSidebars.seatmap.text.usbOutlet'
            ],
            images: [
                { src: './assets/images/ancillaries/seats/A320-Neo/Comfort/01.jpg', label: 'addMoreSidebars.seatmap.label.preferredSEAT' },
                { src: './assets/images/ancillaries/seats/A320-Neo/Comfort/02.jpg', label: 'addMoreSidebars.seatmap.label.preferredSEAT' },
                { src: './assets/images/ancillaries/seats/A320-Neo/Comfort/03.jpg', label: 'addMoreSidebars.seatmap.label.preferredSEAT' },
                { src: './assets/images/ancillaries/seats/A320-Neo/Comfort/04.jpg', label: 'addMoreSidebars.seatmap.label.preferredSEAT' },
                { src: './assets/images/ancillaries/seats/A320-Neo/Comfort/05.jpg', label: 'addMoreSidebars.seatmap.label.preferredSEAT' },
                { src: './assets/images/ancillaries/seats/A320-Neo/Comfort/06.jpg', label: 'addMoreSidebars.seatmap.label.preferredSEAT' },
                { src: './assets/images/ancillaries/seats/A320-Neo/Comfort/07.jpg', label: 'addMoreSidebars.seatmap.label.preferredSEAT' }
            ]
        },
        standard: {
            features: ['addMoreSidebars.seatmap.text.standardLegroom'],
            images: [
                { src: './assets/images/ancillaries/seats/A320-Neo/Standard/01.jpg', label: 'addMoreSidebars.seatmap.label.standardSEAT' },
                { src: './assets/images/ancillaries/seats/A320-Neo/Standard/02.jpg', label: 'addMoreSidebars.seatmap.label.standardSEAT' },
                { src: './assets/images/ancillaries/seats/A320-Neo/Standard/03.jpg', label: 'addMoreSidebars.seatmap.label.standardSEAT' },
            ]
},						
    },
    'A320': {
        business: {
            features: [
                'addMoreSidebars.seatmap.text.greaterComfort',
                'addMoreSidebars.seatmap.text.recliningHeadrest',
                'addMoreSidebars.seatmap.text.electricalUsbOutlets'
            ],
            images: [
                { src: './assets/images/ancillaries/seats/A320-200/Executive/01.jpg', label: 'addMoreSidebars.seatmap.label.businessSEAT' },
                { src: './assets/images/ancillaries/seats/A320-200/Executive/02.jpg', label: 'addMoreSidebars.seatmap.label.businessSEAT' },
                { src: './assets/images/ancillaries/seats/A320-200/Executive/03.jpg', label: 'addMoreSidebars.seatmap.label.businessSEAT' },
                { src: './assets/images/ancillaries/seats/A320-200/Executive/04.jpg', label: 'addMoreSidebars.seatmap.label.businessSEAT' },
                { src: './assets/images/ancillaries/seats/A320-200/Executive/05.jpg', label: 'addMoreSidebars.seatmap.label.businessSEAT' },
                { src: './assets/images/ancillaries/seats/A320-200/Executive/06.jpg', label: 'addMoreSidebars.seatmap.label.businessSEAT' }
            ]
        },			
        comfort: {
            price: '20.00€',
            features: [
                'addMoreSidebars.seatmap.text.frontOfCabinSeat',
                'addMoreSidebars.seatmap.text.extraReclinable',
                'addMoreSidebars.seatmap.text.moreLegroom',
                'addMoreSidebars.seatmap.text.usbOutlet'
            ],
            images: [
                { src: './assets/images/ancillaries/seats/A320-200/Comfort/01.jpg', label: 'addMoreSidebars.seatmap.label.preferredSEAT' },
                { src: './assets/images/ancillaries/seats/A320-200/Comfort/02.jpg', label: 'addMoreSidebars.seatmap.label.preferredSEAT' },
                { src: './assets/images/ancillaries/seats/A320-200/Comfort/03.jpg', label: 'addMoreSidebars.seatmap.label.preferredSEAT' },
                { src: './assets/images/ancillaries/seats/A320-200/Comfort/04.jpg', label: 'addMoreSidebars.seatmap.label.preferredSEAT' },
                { src: './assets/images/ancillaries/seats/A320-200/Comfort/05.jpg', label: 'addMoreSidebars.seatmap.label.preferredSEAT' },
                { src: './assets/images/ancillaries/seats/A320-200/Comfort/06.jpg', label: 'addMoreSidebars.seatmap.label.preferredSEAT' },
                { src: './assets/images/ancillaries/seats/A320-200/Comfort/07.jpg', label: 'addMoreSidebars.seatmap.label.preferredSEAT' }
            ]
        },
        standard: {
            features: ['addMoreSidebars.seatmap.text.standardLegroom'],
            images: [
                { src: './assets/images/ancillaries/seats/A320-200/Standard/01.jpg', label: 'addMoreSidebars.seatmap.label.standardSEAT' },
                { src: './assets/images/ancillaries/seats/A320-200/Standard/02.jpg', label: 'addMoreSidebars.seatmap.label.standardSEAT' },
                { src: './assets/images/ancillaries/seats/A320-200/Standard/03.jpg', label: 'addMoreSidebars.seatmap.label.standardSEAT' },
            ]
        },						
    },
    'A320200': {
        business: {
            features: [
                'addMoreSidebars.seatmap.text.greaterComfort',
                'addMoreSidebars.seatmap.text.recliningHeadrest',
                'addMoreSidebars.seatmap.text.electricalUsbOutlets'
            ],
            images: [
                { src: './assets/images/ancillaries/seats/A320-200/Executive/01.jpg', label: 'addMoreSidebars.seatmap.label.businessSEAT' },
                { src: './assets/images/ancillaries/seats/A320-200/Executive/02.jpg', label: 'addMoreSidebars.seatmap.label.businessSEAT' },
                { src: './assets/images/ancillaries/seats/A320-200/Executive/03.jpg', label: 'addMoreSidebars.seatmap.label.businessSEAT' },
                { src: './assets/images/ancillaries/seats/A320-200/Executive/04.jpg', label: 'addMoreSidebars.seatmap.label.businessSEAT' },
                { src: './assets/images/ancillaries/seats/A320-200/Executive/05.jpg', label: 'addMoreSidebars.seatmap.label.businessSEAT' },
                { src: './assets/images/ancillaries/seats/A320-200/Executive/06.jpg', label: 'addMoreSidebars.seatmap.label.businessSEAT' }
            ]
        },			
        comfort: {
            features: [
                'addMoreSidebars.seatmap.text.frontOfCabinSeat',
                'addMoreSidebars.seatmap.text.extraReclinable',
                'addMoreSidebars.seatmap.text.moreLegroom',
                'addMoreSidebars.seatmap.text.usbOutlet'
            ],
            images: [
                { src: './assets/images/ancillaries/seats/A320-200/Comfort/01.jpg', label: 'addMoreSidebars.seatmap.label.preferredSEAT' },
                { src: './assets/images/ancillaries/seats/A320-200/Comfort/02.jpg', label: 'addMoreSidebars.seatmap.label.preferredSEAT' },
                { src: './assets/images/ancillaries/seats/A320-200/Comfort/03.jpg', label: 'addMoreSidebars.seatmap.label.preferredSEAT' },
                { src: './assets/images/ancillaries/seats/A320-200/Comfort/04.jpg', label: 'addMoreSidebars.seatmap.label.preferredSEAT' },
                { src: './assets/images/ancillaries/seats/A320-200/Comfort/05.jpg', label: 'addMoreSidebars.seatmap.label.preferredSEAT' },
                { src: './assets/images/ancillaries/seats/A320-200/Comfort/06.jpg', label: 'addMoreSidebars.seatmap.label.preferredSEAT' },
                { src: './assets/images/ancillaries/seats/A320-200/Comfort/07.jpg', label: 'addMoreSidebars.seatmap.label.preferredSEAT' }
            ]
        },
        standard: {
            features: ['addMoreSidebars.seatmap.text.standardLegroom'],
            images: [
                { src: './assets/images/ancillaries/seats/A320-200/Standard/01.jpg', label: 'addMoreSidebars.seatmap.label.standardSEAT' },
                { src: './assets/images/ancillaries/seats/A320-200/Standard/02.jpg', label: 'addMoreSidebars.seatmap.label.standardSEAT' },
                { src: './assets/images/ancillaries/seats/A320-200/Standard/03.jpg', label: 'addMoreSidebars.seatmap.label.standardSEAT' },
            ]
        },
     
    },
    'A319': {
        business: {
            features: [
                'addMoreSidebars.seatmap.text.greaterComfort',
                'addMoreSidebars.seatmap.text.recliningHeadrest',
                'addMoreSidebars.seatmap.text.electricalUsbOutlets'
            ],
            images: [
                { src: './assets/images/ancillaries/seats/A319/Executive/01.jpg', label: 'addMoreSidebars.seatmap.label.businessSEAT' },
                { src: './assets/images/ancillaries/seats/A319/Executive/02.jpg', label: 'addMoreSidebars.seatmap.label.businessSEAT' },
                { src: './assets/images/ancillaries/seats/A319/Executive/03.jpg', label: 'addMoreSidebars.seatmap.label.businessSEAT' },
                { src: './assets/images/ancillaries/seats/A319/Executive/04.jpg', label: 'addMoreSidebars.seatmap.label.businessSEAT' },
                { src: './assets/images/ancillaries/seats/A319/Executive/05.jpg', label: 'addMoreSidebars.seatmap.label.businessSEAT' },
                { src: './assets/images/ancillaries/seats/A319/Executive/06.jpg', label: 'addMoreSidebars.seatmap.label.businessSEAT' }

            ]
        },			
        comfort: {
            price: '20.00€',
            features: [
                'addMoreSidebars.seatmap.text.frontOfCabinSeat',
                'addMoreSidebars.seatmap.text.moreLegroom',
                'addMoreSidebars.seatmap.text.extraReclinable',
                'addMoreSidebars.seatmap.text.usbOutlet'
            ],
            images: [
                { src: './assets/images/ancillaries/seats/A319/Comfort/01.jpg', label: 'addMoreSidebars.seatmap.label.preferredSEAT' },
                { src: './assets/images/ancillaries/seats/A319/Comfort/02.jpg', label: 'addMoreSidebars.seatmap.label.preferredSEAT' },
                { src: './assets/images/ancillaries/seats/A319/Comfort/03.jpg', label: 'addMoreSidebars.seatmap.label.preferredSEAT' },
                { src: './assets/images/ancillaries/seats/A319/Comfort/04.jpg', label: 'addMoreSidebars.seatmap.label.preferredSEAT' },
                { src: './assets/images/ancillaries/seats/A319/Comfort/05.jpg', label: 'addMoreSidebars.seatmap.label.preferredSEAT' },
                { src: './assets/images/ancillaries/seats/A319/Comfort/06.jpg', label: 'addMoreSidebars.seatmap.label.preferredSEAT' },
                { src: './assets/images/ancillaries/seats/A319/Comfort/07.jpg', label: 'addMoreSidebars.seatmap.label.preferredSEAT' },
                { src: './assets/images/ancillaries/seats/A319/Comfort/08.jpg', label: 'addMoreSidebars.seatmap.label.preferredSEAT' }
            ]
        },
        standard: {
            features: ['addMoreSidebars.seatmap.text.standardLegroom'],
            images: [
                { src: './assets/images/ancillaries/seats/A319/Standard/01.jpg', label: 'addMoreSidebars.seatmap.label.standardSEAT' },
                { src: './assets/images/ancillaries/seats/A319/Standard/02.jpg', label: 'addMoreSidebars.seatmap.label.standardSEAT' },
                { src: './assets/images/ancillaries/seats/A319/Standard/03.jpg', label: 'addMoreSidebars.seatmap.label.standardSEAT' },
            ]
        }
    },
    'ATR': {
        comfort: {
            features: ['addMoreSidebars.seatmap.text.frontOfCabinSeat'],
            images: [
                { src: './assets/images/ancillaries/seats/ATR72/Comfort/01.jpg', label: 'addMoreSidebars.seatmap.label.preferredSEAT' },
            ]
        },
        standard: {
            features: ['addMoreSidebars.seatmap.text.standardLegroom'],
            images: [
                { src: './assets/images/ancillaries/seats/ATR72/Standard/01.jpg', label: 'addMoreSidebars.seatmap.label.standardSEAT' },
            ]
        },		
    },
    'ER190': {
        business: {
            features: [
                'addMoreSidebars.seatmap.text.greaterComfort',
            ],
            images: [
                { src: './assets/images/ancillaries/seats/Emb190/Executive/01.jpg', label: 'addMoreSidebars.seatmap.label.businessSEAT' },
                { src: './assets/images/ancillaries/seats/Emb190/Executive/02.jpg', label: 'addMoreSidebars.seatmap.label.businessSEAT' }
            ]
        },
        comfort: {
            features: [
                'addMoreSidebars.seatmap.text.frontOfCabinSeat',
                'addMoreSidebars.seatmap.text.reclinableSeat',
                'addMoreSidebars.seatmap.text.standardLegroom'
            ],
            images: [
                { src: './assets/images/ancillaries/seats/Emb190/Comfort/01.jpg', label: 'addMoreSidebars.seatmap.label.preferredSEAT' },
                { src: './assets/images/ancillaries/seats/Emb190/Comfort/02.jpg', label: 'addMoreSidebars.seatmap.label.preferredSEAT' }
            ]
        },
        standard: {
            features: [
                'addMoreSidebars.seatmap.text.reclinableSeat',
                'addMoreSidebars.seatmap.text.standardLegroom',
            ],
            images: [
                { src: './assets/images/ancillaries/seats/Emb190/Standard/01.jpg', label: 'addMoreSidebars.seatmap.label.standardSEAT' },
                { src: './assets/images/ancillaries/seats/Emb190/Standard/02.jpg', label: 'addMoreSidebars.seatmap.label.standardSEAT' }
            ]
        },		
    },
    'ER195':{
        business: {
            features: [
                'addMoreSidebars.seatmap.text.greaterComfort',
            ],
            images: [
                { src: './assets/images/ancillaries/seats/Emb195/Executive/01.jpg', label: 'addMoreSidebars.seatmap.label.businessSEAT' },
                { src: './assets/images/ancillaries/seats/Emb195/Executive/02.jpg', label: 'addMoreSidebars.seatmap.label.businessSEAT' }
            ]
        },
        comfort: {
            features: [
                'addMoreSidebars.seatmap.text.frontOfCabinSeat',
                'addMoreSidebars.seatmap.text.reclinableSeat',
                'addMoreSidebars.seatmap.text.standardLegroom'
            ],
            images: [
                { src: './assets/images/ancillaries/seats/Emb195/Comfort/01.jpg', label: 'addMoreSidebars.seatmap.label.preferredSEAT' },
                { src: './assets/images/ancillaries/seats/Emb195/Comfort/02.jpg', label: 'addMoreSidebars.seatmap.label.preferredSEAT' }
            ]
        },
        standard: {
            features: [
                'addMoreSidebars.seatmap.text.reclinableSeat',
                'addMoreSidebars.seatmap.text.standardLegroom',
            ],
            images: [
                { src: './assets/images/ancillaries/seats/Emb195/Standard/01.jpg', label: 'addMoreSidebars.seatmap.label.standardSEAT' },
            ]
        }	
    },
    default: {
            business: {
                features: ['addMoreSidebars.seatmap.text.fullFlatReclinableSeat', 
                           'addMoreSidebars.seatmap.text.widerSeats', 
                           'addMoreSidebars.seatmap.text.backrestLevels',
                           'addMoreSidebars.seatmap.text.usbOutlet'
                        ],
            },
            comfort: {
                features: [
                    'addMoreSidebars.seatmap.text.frontOfCabinSeat',
                    'addMoreSidebars.seatmap.text.extraReclinable',
                    'addMoreSidebars.seatmap.text.moreLegroom',
                    'addMoreSidebars.seatmap.text.usbOutlet'
                ],
                images: [
                    { src: './assets/images/ancillaries/seats/1.jpg', label: 'addMoreSidebars.seatmap.label.preferredSEAT' },
                    { src: './assets/images/ancillaries/seats/2.jpg', label: 'addMoreSidebars.seatmap.label.preferredSEAT' }
                ]
            },
            legroom: {
                features: [
                    'addMoreSidebars.seatmap.text.frontRowSeat',
                    'addMoreSidebars.seatmap.text.moreLegroom',
                    'addMoreSidebars.seatmap.text.usbOutlet'
                ],
            },
            standard: {
                features: [
                    'addMoreSidebars.seatmap.text.reclinableSeat',
                    'addMoreSidebars.seatmap.text.standardLegroom',
                    'addMoreSidebars.seatmap.text.usbOutlet'
                ],
            },
            emergency: {
                features: ['addMoreSidebars.seatmap.text.extraLegroom'],
                images: [{src: './assets/images/ancillaries/seats/default/ExitRow/01.jpg', label: 'addMoreSidebars.seatmap.label.emergencySEAT'}]
            },
        }
};	

export const seatCharacteristicsDefault = {
    comfort: {
        price: '20.00€',
        cssClass: 'comfort',
        label: 'addMoreSidebars.seatmap.text.comfort',
        features: ['addMoreSidebars.seatmap.text.frontOfCabinSeat'],
        // image: 'sprite.svg#logo--economy_extra',
        svgCssClass: 'seat-charact-logo--economy_xtra',

    },
    legroom: {
        price: '20.00€',
        cssClass: 'legroom',
        label: 'addMoreSidebars.seatmap.text.legSpace',
        // image: 'sprite.svg#logo--economy_extra',
        svgCssClass: 'seat-charact-logo--economy_xtra',
        features: ['addMoreSidebars.seatmap.text.extraLegroom'],
    },
    standard: {
        price: '20.00€',
        cssClass: 'standard',
        label: 'addMoreSidebars.seatmap.text.standard',
        //image: 'sprite.svg#logo--economy',
        svgCssClass: 'seat-charact-logo--economy',
        features: ['addMoreSidebars.seatmap.text.standardLegroom']
    },
    business: {
        price: '30.00€',
        cssClass: 'business',
        label: 'addMoreSidebars.seatmap.text.executive',
        features: ['addMoreSidebars.seatmap.text.greaterComfort'],
        images: [
            { src: './assets/images/ancillaries/seats/18.jpg', label: 'addMoreSidebars.seatmap.title.businessSeat' },
            { src: './assets/images/ancillaries/seats/17.jpg', label: 'addMoreSidebars.seatmap.title.businessSeat' },
            { src: './assets/images/ancillaries/seats/16.jpg', label: 'addMoreSidebars.seatmap.title.businessSeat' },
            { src: './assets/images/ancillaries/seats/15.jpg', label: 'addMoreSidebars.seatmap.title.businessSeat' },
            { src: './assets/images/ancillaries/seats/14.jpg', label: 'addMoreSidebars.seatmap.title.businessSeat' },
            { src: './assets/images/ancillaries/seats/13.jpg', label: 'addMoreSidebars.seatmap.title.businessSeat' },
            { src: './assets/images/ancillaries/seats/12.jpg', label: 'addMoreSidebars.seatmap.title.businessSeat' }
        ]
    },
    emergency: {
        price: '30.00€',
        cssClass: 'emergency',
        icon: 'sprite.svg#misc--emergency-exit-icon',
        label: 'addMoreSidebars.seatmap.text.exitRow',
        features: ['addMoreSidebars.seatmap.text.extraLegroom'],
        images: [
            { src: './assets/images/ancillaries/seats/default/ExitRow/01.jpg', label: 'addMoreSidebars.seatmap.label.emergencySEAT' },
        ]
    }
};